import React, { Fragment, useState, useEffect } from "react";
import i18n from 'i18next';
import { OverlayTrigger, Tooltip } from "react-bootstrap";


export default function StatusFilter({ options, filter, onChange, canAddPeople }) {

    const [state, setState] = useState({ showDropdown: false, hasChanges: false, tmpSelected: [] });

    const selected = [];
    if (!(filter.authenticated && filter.unpublished)) {
        if (filter.authenticated)
            selected.push(1);
        if (filter.unpublished)
            selected.push(2);
    }


    // Click handler
    useEffect(() => {
        document.addEventListener('mousedown', clickOutsideDropdown, false);
        document.addEventListener('touchstart', clickOutsideDropdown, false);

        return function cleanup() {
            document.removeEventListener('mousedown', clickOutsideDropdown, false);
            document.removeEventListener('touchstart', clickOutsideDropdown, false);
        }
    }, []);

    function clickOutsideDropdown(event) {
        if (document.getElementById("status-filter") && !document.getElementById("status-filter").contains(event.target)) {
            setState(s => ({ ...s, showDropdown: false }));
        }
    }

    function toggleDropdown() {
        setState(s => ({ ...s, showDropdown: !s.showDropdown, hasChanges: false, tmpSelected: selected.slice() }));
    }

    function toggleOption(option) {
        if (option !== "all") {
            const index = state.tmpSelected.findIndex(id => id === option.id);
            if (index >= 0)
                state.tmpSelected.splice(index, 1);
            else
                state.tmpSelected.push(option.id);
        }

        if (option === "all" || state.tmpSelected.length === options.length) {
            state.tmpSelected = [];
        }

        setState({ ...state, hasChanges: true });
    }

    function clear() {
        state.tmpSelected = [1, 2];
        apply();
    }

    function apply() {
        onChange(state.tmpSelected);
        toggleDropdown();
    }

    function getFilterText() {
        var checked = state.showDropdown ? state.tmpSelected : selected;

        if (checked.length === 0)
            return i18n.t("people.all");
        else if (checked.length === 1)
            return options.find(o => o.id === checked[0]).name;
        else
            return checked.length + i18n.t("people.selected");
    }

    return (
        <div id="status-filter" className={canAddForms ? 'col-sm-2 col-xs-12 filter-dropdown' : 'col-sm-3 col-xs-12 filter-dropdown'}>
            <div className="dropdown-container" data-qa="fb-dashboard-select-filter-status">

                <OverlayTrigger placement="top" overlay={<Tooltip className='fms-tooltip'><PopoverTooltip options={options} selected={state.showDropdown ? state.tmpSelected : selected} /></Tooltip>}>
                    <div className="selected-filter" onClick={toggleDropdown}>
                        <div className="filter-container">
                            <span>{i18n.t("people.status.status")}</span>
                            <span className="filter-items fm-status">{"\u00A0"}- {getFilterText()}</span> <i className="fms-chevron-down"></i>
                        </div>
                    </div>
                </OverlayTrigger>

                {state.showDropdown &&
                    <div className="filter-options">
                        <div className="options-container statuses">


                            <div className="filter-option" onClick={() => toggleOption('all')}>
                                {state.tmpSelected.length === 0 && <i className="fms-checkbox-check"></i>}
                                <span>{i18n.t("people.all")}</span>
                            </div>


                            {options.map(option =>
                                <div className="filter-option" onClick={() => toggleOption(option)} key={option.id}>
                                    {state.tmpSelected.indexOf(option.id) >= 0 && <i className="fms-checkbox-check"></i>}
                                    <span>{option.name}</span>
                                </div>
                            )}
                        </div>
                        {state.hasChanges &&
                            <Fragment>
                                <div className="clear-filter">
                                    <span onClick={clear}>{i18n.t("people.clear")}</span>
                                </div>
                                <div className="apply-filter">
                                    <span onClick={apply}>{i18n.t("people.apply")}</span>
                                </div>
                            </Fragment>
                        }
                    </div>
                }
            </div>
        </div>
    );
}


function PopoverTooltip({ options, selected }) {
    return (
        <div className="tooltip-content" data-qa="tooltip-filter-list-status">
            {selected.length === 0 &&
                <div><span>{i18n.t("people.all")}</span></div>
            }
            {selected.map(id => options.find(o => o.id === id)).map(option =>
                <div key={option.id}><span>{option.name}</span></div>
            )}
        </div>
    );
}
